import { render, staticRenderFns } from "./O_Peremeshenie_naslad.vue?vue&type=template&id=1949ec5b&scoped=true&"
import script from "./O_Peremeshenie_naslad.vue?vue&type=script&lang=js&"
export * from "./O_Peremeshenie_naslad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949ec5b",
  null
  
)

export default component.exports